import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../context/LanguageContext';
import MarqueeCarousel from './Carousel';

const GroupOverview: React.FC = () => {
  const [content, setContent] = useState<any>(null);
  const { t_api } = useLanguage();
  const controlsHeading = useAnimation();
  const [refHeading, inViewHeading] = useInView({ triggerOnce: false });
  const controlsUnderline = useAnimation();
  const [refUnderline, inViewUnderline] = useInView({ triggerOnce: false });
  const controlsPara = useAnimation();
  const [refPara, inViewPara] = useInView({ triggerOnce: false });
  const controlsCarousel = useAnimation();
  const [refCarousel, inViewCarousel] = useInView({ triggerOnce: false });

  useEffect(() => {
    fetch('/api/homepage/content')
      .then(res => res.json())
      .then(data => setContent(data.Group || {}))
      .catch(err => console.warn('Group overview content unavailable:', err));
  }, []);

  useEffect(() => {
    if (inViewHeading) controlsHeading.start({ opacity: 1, y: 0 });
    else controlsHeading.start({ opacity: 0, y: -30 });
    if (inViewUnderline) controlsUnderline.start({ scaleX: 1 });
    else controlsUnderline.start({ scaleX: 0 });
    if (inViewPara) controlsPara.start({ opacity: 1, y: 0 });
    else controlsPara.start({ opacity: 0, y: 30 });
    if (inViewCarousel) controlsCarousel.start({ opacity: 1, y: 0 });
    else controlsCarousel.start({ opacity: 0, y: 40 });
  }, [inViewHeading, inViewUnderline, inViewPara, inViewCarousel, controlsHeading, controlsUnderline, controlsPara, controlsCarousel]);

  return (
    <section className="py-10 bg-gray">
      <div className="container mx-auto px-4">
        <motion.h2 ref={refHeading} className="text-3xl font-bold text-center text-dark mb-2" initial={{ opacity: 0, y: -30 }} animate={controlsHeading}>{t_api(content?.title || 'Our Group', content?.title_ar)}</motion.h2>
        <motion.div ref={refUnderline} className="w-20 h-1 bg-[#F2BB13] mx-auto mb-8 rounded" initial={{ scaleX: 0 }} animate={controlsUnderline} style={{ transformOrigin: 'center' }} />
        <motion.p ref={refPara} className="text-lg text-dark text-center max-w-3xl mx-auto mb-12" initial={{ opacity: 0, y: 30 }} animate={controlsPara}>{t_api(content?.subtitle || 'Portfolio offers comprehensive solutions across transport, construction, and distribution.', content?.subtitle_ar)}</motion.p>
        <motion.div ref={refCarousel} initial={{ opacity: 0, y: 40 }} animate={controlsCarousel}><MarqueeCarousel /></motion.div>
      </div>
    </section>
  );
};

export default GroupOverview;
